<div class="quick-search">
<app-quick-search-auto-complete (onsymbolChanged)="selectAsset($event)" ></app-quick-search-auto-complete>
</div>
